import React from 'react';
import {ru} from "../data/ru"
import {by} from "../data/by"
import style from './information.module.css'
import Card from "./Card";
import {BASE_URL, FILE_URL} from "../../config";
const Information = () => {
    let language = localStorage.getItem('lang') === 'ru' ? ru.about : by.about
    const instruction = <div className={style.instruction}>
        <a href={BASE_URL + FILE_URL + '/teacher'}>{language.forTeacher}</a>
        <br/>
        <a href={BASE_URL + FILE_URL + '/student'}>{language.forStudent}</a>
        <br/>
        <a href={BASE_URL + FILE_URL + '/curator'}>{language.forCurator}</a>
        <br/>
        {/* <a  href={BASE_URL + FILE_URL + '/expert'}>{language.forExpert}</a> */}
    </div>
    const technical  = <div className={`${style.technical} ${style.instruction}`}>
        <a href={BASE_URL + FILE_URL + '/technical'}>{`Технические требования (.dox)`}</a>
    </div>
    return (
        <div className={style.bgPicture}>
            <div className={style.blackout}>
                <div className={style.mainContainer}>
                    <div className={style.mainDescriptionPanel}>
                        {language.centralText}
                        <div style={{marginTop:'50px',textAlign:'center'}}>
                            <h1>Контактные телефоны специалистов ГИАЦ Министерства образования по техническому сопровождению</h1>
                            <h2>250-15-76</h2>
                            <h2>250-61-09</h2>
                        </div>
                        <Card title={language.instruction} text={instruction}/>
                        <Card title={'Технические требования'} text={technical}/>

                    </div>
                    <div className={style.cardBox}>
                        <Card title={language.card1} text={language.card1Text}/>
                        <Card title={language.card2} text={language.card2Text}/>
                        <Card title={language.card3} text={language.card3Text}/>
                        <Card title={language.card4} text={language.card4Text}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Information;